import { FONT_SIZES, FONT_SIZE_DEFAULT_INDEX } from '../config/settings';
import { setFontSizeVar, removeCssVar } from '../utils/domHelpers';
import { CSS_VARS } from '../utils/constants';

export function applyFontSize(index) {
  if (index >= 0 && index < FONT_SIZES.length) {
    setFontSizeVar(FONT_SIZES[index]);
  }
}

export function removeFontSize() {
  removeCssVar(CSS_VARS.fontSize);
}

export function increaseFontSize(currentIndex) {
  return Math.min(currentIndex + 1, FONT_SIZES.length - 1);
}

export function decreaseFontSize(currentIndex) {
  return Math.max(currentIndex - 1, 0);
}

export function isFontSizeDefault(index) {
  return index === FONT_SIZE_DEFAULT_INDEX;
}
